import React from 'react';
import { Accordion, Image } from 'react-bootstrap';
import * as S from './styles';

export interface IFaqContainerProps {
  faqConfig: {
    title?: string;
    description?: string | string[];
    image?: string;
  }[];
}

export const FaqContainer = (props: IFaqContainerProps) => {
  const { faqConfig } = props;
  console.log('AsirfaqConfig', faqConfig);

  const _renderImageIf = (image: string) => {
    if (image) {
      return <Image src={image} />;
    }
  };

  const _renderDescriptionIf = (description: string | string[]) => {
    if (description && typeof description === 'string') {
      // Split by \n\n to create paragraphs
      const paragraphs = description.split('\n\n').map((text, index) => {
        // Replace URLs with <a> tags
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        const formattedText = text.replace(
          urlRegex,
          (url) => `<a href="${url}" class="faq-link text-blue-500">${url}</a>`
        );
        return (
          <p
            key={`desc-${index}`}
            dangerouslySetInnerHTML={{ __html: formattedText }}
          />
        );
      });
      return <>{paragraphs}</>;
    }
    if (Array.isArray(description)) {
      return (
        <>
          {description?.map((str, index) => {
            // Handle URLs in array items
            const urlRegex = /(https?:\/\/[^\s]+)/g;
            const formattedText = str.replace(
              urlRegex,
              (url) => `<a href="${url}" class="faq-link">${url}</a>`
            );
            return (
              <p
                key={`desc-${index}`}
                dangerouslySetInnerHTML={{ __html: formattedText }}
              />
            );
          })}
        </>
      );
    }
  };

  const _getAccordionData = () => {
    let _tempData =
      Array.isArray(faqConfig) &&
      faqConfig?.map((item: any, index: number) => {
        return (
          <Accordion.Item eventKey={`acc-${index}`} key={`acc-${index}`}>
            <Accordion.Header>
              <S.AccHeader>{item?.title}</S.AccHeader>
            </Accordion.Header>
            <Accordion.Body>
              {_renderDescriptionIf(item?.description)}
              {_renderImageIf(item?.image)}
            </Accordion.Body>
          </Accordion.Item>
        );
      });
    return (
      <Accordion defaultActiveKey="acc-0">
        <S.AccHeader>Frequently Asked Questions</S.AccHeader>
        {_tempData}
      </Accordion>
    );
  };

  return (
    <S.ColContainer md={5} xs={12} lg={12}>
      {_getAccordionData()}
    </S.ColContainer>
  );
};

FaqContainer.defaultProps = {
  faqConfig: [],
};